import React from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

function AudioPreviewModal({
  openPreviewAudio,
  handleClosePreviewAudio,
  audioUrl,
}) {
  return (
    <Modal
      open={openPreviewAudio}
      onClose={handleClosePreviewAudio}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "65vw",
          height: "25vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "column",
          gap: "30%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "black",
            padding: "10px",
          }}
        >
          <KeyboardBackspaceIcon
            style={{ color: "white", cursor: "pointer" }}
            onClick={handleClosePreviewAudio}
          />
          <CloseIcon
            style={{ color: "white", cursor: "pointer" }}
            onClick={handleClosePreviewAudio}
          />
        </div>
        <audio
          src={audioUrl}
          alt="Selected"
          style={{ width: "100%" }}
          controls
          autoPlay
        />
      </Box>
    </Modal>
  );
}

export default AudioPreviewModal;
